define.alias("shared/components/shared/choose-your-upgrade/plan-card", "settings/components/shared/choose-your-upgrade/plan-card");